export const ConfigName = 'lakemedel';
export const ModuleName = 'lakemedel';
export const TableName = 'Läkemedel';
export const DisplayName = 'Läkemedel';

export const ToxIdentifiers = ['2', 'toxicitet', 'dod_toxicitet'];
export const ShowStopSpecIdentifiers = ['9', 'annan_orsak', 'dod_annan'];
